import { useEffect } from 'react';
import gtmService from '../../../../../utils/gtm';
import { useRootSelector } from '../../../../../store/hooks';
import { selectPageConfig } from '../../../../../store/features/pageConfig';
import { SiteTypes } from '../../../../../types';
import { PricingProductsMeta } from '../../../store/features/products/types';

export interface UseDivisionGTMProps {
  divisionId: string;
  divisionInfrontBusinessUnit: string;
  divisionName: string;
  disablePushDataToGTM?: boolean;
}

export const useDivisionGTM = (props: UseDivisionGTMProps) => {
  const {
    divisionId,
    divisionInfrontBusinessUnit,
    divisionName,
    disablePushDataToGTM,
  } = props;
  const { siteType } = useRootSelector(selectPageConfig);

  useEffect(() => {
    if (!disablePushDataToGTM && siteType === SiteTypes.COURSE) {
      gtmService.pushDivisionOption({
        divisionId,
        divisionName,
        divisionInfrontBusinessUnit,
      } as PricingProductsMeta);
    }
    // eslint-disable-next-line
  }, []);
};
